/**
 * First-touch affiliate attribution on the client.
 *
 * When a visitor lands on /r/:code we drop a `dunea_ref` cookie (only if one
 * isn't already set — first touch wins) and forward the code with the next
 * signup so the backend can bind the referral.
 */
const REF_COOKIE = 'dunea_ref';
const REF_MAX_AGE_DAYS = 60;

export function getAffiliateRef(): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const match = document.cookie.split('; ').find((row) => row.startsWith(`${REF_COOKIE}=`));

  if (!match) {
    return undefined;
  }

  const value = decodeURIComponent(match.slice(REF_COOKIE.length + 1));

  return value || undefined;
}

/** Set the first-touch ref cookie. No-op if one already exists. */
export function setAffiliateRefIfAbsent(code: string): void {
  if (typeof document === 'undefined' || !code) {
    return;
  }

  if (getAffiliateRef()) {
    return;
  }

  const maxAge = REF_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${REF_COOKIE}=${encodeURIComponent(code)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}
